// TODO: clean this up while building the new product page. Maybe use the default product form, and add the accessory fee logic to onCartUpdate in cart.js

// A reusable function to update the hidden year input from the URL
function updateYearInput() {
  // Find the input field every time, in case the DOM was updated
  const yearInput = document.querySelector('input[name="properties[_Year]"], input[name="properties[year]"]');
  if (!yearInput) return;

  // Read the current URL's parameters
  const params = new URLSearchParams(window.location.search);
  const year = params.get('year');

  if (year) {
    yearInput.value = year;
  }
}



document.addEventListener('DOMContentLoaded', () => {
	updateYearInput();

	const form = document.querySelector('form[action$="/cart/add"]');
	const btns = document.querySelectorAll('#btnAddToCart');
  if (!form || !btns) return;
	
  const drawerElement = document.querySelector('cart-drawer');
  const quantityInput = document.querySelector('#Quantity');
  const yearInput = document.querySelector('[name="properties[year]"]');

  form.addEventListener('submit', async (e) => {
		e.preventDefault();
		
    const formData = new FormData(form);
    const variantId = parseInt(formData.get('id'), 10);
    if (!variantId) return;
		
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
    const year = yearInput ? yearInput.value.trim() : '';
		
    const item = { id: variantId, quantity };
    if (year) {
      item.properties = { year };
    }

		btns.forEach((btn) => {
			btn.innerHTML = '<span class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" class="icon icon-spinner fa-spin"><!--!Font Awesome Free 7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path d="M272 112C272 85.5 293.5 64 320 64C346.5 64 368 85.5 368 112C368 138.5 346.5 160 320 160C293.5 160 272 138.5 272 112zM272 528C272 501.5 293.5 480 320 480C346.5 480 368 501.5 368 528C368 554.5 346.5 576 320 576C293.5 576 272 554.5 272 528zM112 272C138.5 272 160 293.5 160 320C160 346.5 138.5 368 112 368C85.5 368 64 346.5 64 320C64 293.5 85.5 272 112 272zM480 320C480 293.5 501.5 272 528 272C554.5 272 576 293.5 576 320C576 346.5 554.5 368 528 368C501.5 368 480 346.5 480 320zM139 433.1C157.8 414.3 188.1 414.3 206.9 433.1C225.7 451.9 225.7 482.2 206.9 501C188.1 519.8 157.8 519.8 139 501C120.2 482.2 120.2 451.9 139 433.1zM139 139C157.8 120.2 188.1 120.2 206.9 139C225.7 157.8 225.7 188.1 206.9 206.9C188.1 225.7 157.8 225.7 139 206.9C120.2 188.1 120.2 157.8 139 139zM501 433.1C519.8 451.9 519.8 482.2 501 501C482.2 519.8 451.9 519.8 433.1 501C414.3 482.2 414.3 451.9 433.1 433.1C451.9 414.3 482.2 414.3 501 433.1z"/></svg></span> Adding ...';
		});

    try {
      // Add selected item to cart
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item] })
      });

      // Refresh UI
      await refreshCartSections();
      drawerElement?.open();

    } catch (err) {
      console.error('Add to cart failed:', err);
    } finally {
			btns.forEach((btn) => {
				btn.innerHTML = window.variantStrings.addToCart;
			});
		}
  });
});

async function refreshCartSections(sections) {
	if (!sections) {
		const sectionsToRender = 'cart-icon-bubble,cart-drawer,main-cart-items';
		const res = await fetch(`${window.location.pathname}?sections=${sectionsToRender}`);

		sections = await res.json();
	}

	// Update cart icon bubble
	const iconHtml = sections["cart-icon-bubble"];
	if (iconHtml) {
		const iconTarget = document.getElementById("cart-icon-bubble");
		if (iconTarget) {
			const parsedIcon = new DOMParser().parseFromString(iconHtml, "text/html").body
				.firstElementChild.innerHTML;
			if (parsedIcon) iconTarget.innerHTML = parsedIcon;
		}
	}

	// Update and open cart drawer
	const drawerHtml = sections["cart-drawer"];
	if (drawerHtml) {
		const drawerTarget = document.querySelector("#CartDrawer");
		const parsedDrawer = new DOMParser()
			.parseFromString(drawerHtml, "text/html")
			.querySelector("#CartDrawer");
		const drawerElement = document.querySelector("cart-drawer");

		if (drawerTarget && parsedDrawer) {
			drawerTarget.innerHTML = parsedDrawer.innerHTML;
		}

		if (drawerElement) {
			// Check if the drawer content has cart items
			const hasItems = parsedDrawer.querySelector(".cart-item:not(.cart-upsell-item)") !== null;

			if (!hasItems) {
				drawerElement.classList.add("is-empty");
			} else {
				drawerElement.classList.remove("is-empty");
			}
		}
	}

	const mainCartItemsHtml = sections["main-cart-items"];
	const cartItemsElement = document.querySelector("cart-items");
	if (mainCartItemsHtml && cartItemsElement) {
		const parsedMainCartItems = new DOMParser()
			.parseFromString(mainCartItemsHtml, "text/html")
			.querySelector("cart-items");

		cartItemsElement.replaceWith(parsedMainCartItems);
	}
}
